import { isEditorX } from '../../utils/editorx';
const domain = isEditorX ? 'pix.editorx.com' : 'pix.wix.com';
export const defaultSettings = {
  pictureApi: `https://${domain}/services/shutterstock`,
  videoApi: `https://${domain}/services/shutterstock/video`,
  pricesApi: `/_api/premium-store/v1/digital-goods-prices`,
  itemsLimit: 50
};